import React, {useContext, useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {QuestionCircleOutlined} from '@ant-design/icons'
import {Button, message, Modal, Select} from "antd"
import parseToken from "../../../../helpers/parseToken"
import {getApParamV2} from "../../../../services/api/apiLead";
import {updateTenantHub} from "../../../../services/api/apiCustomers";
import CustomerHubContext from "../../context/CustomerHubContext";
import {addTenantHub, searchTenantHub} from "../../../../services/api/apiCustomerHub";

CustomerFormModal.propTypes = {
  item: PropTypes.object,
  type: PropTypes.string,
  label: PropTypes.string,
  createBy: PropTypes.string,
  text: PropTypes.string,
}

function CustomerFormModal(props) {
  const decodeToken = parseToken()
  const {getCustomers} = useContext(CustomerHubContext)
  const {
    item: itemProps,
    label,
    type,
    fetchLeadDetail,
    setNameCus,
    setIsModalVisible,
    isModalVisible
  } = props
  const _newItemProp = {...itemProps}
  const [item, setItem] = useState({..._newItemProp})
  const [loading, setLoading] = useState(false)
  const [validate, setValidate] = useState({})
  const [listTypes, setListTypes] = useState([])
  const [tenants, setTenants] = useState([])
  const [tenantsRaw, setTenantsRaw] = useState([])

  const onChangeItem = (e) => {
    const {name, value} = e.target
    setItem({
      ...item,
      [name]: value
    })
  }

  const onChangeItemSelect = (value, name) => {
    setItem({
      ...item,
      [name]: value
    })
  }

  const onChangeSelectItem = (name, value) => {
    setItem({
      ...item,
      [name]: value
    })
  }

  const onChangeTenantCopy = (tenantId) => {
    if (!tenantId) {
      setItem({...item, tenantIdCopy: undefined})
      return
    }
    const tenant = tenantsRaw.find(t => t.id === tenantId)
    if (tenant) {
      setItem({
        ...item,
        tenantIdCopy: tenantId,
        tax: tenant.tax || '',
        contractNumber: tenant.contractNumber || '',
        deputy: tenant.deputy || '',
        role: tenant.role || '',
        email: tenant.email || '',
        phoneNumber: tenant.phoneNumber || '',
        address: tenant.address || '',
      })
    }
  }

  const _validateData = () => {
    let validateForm = {}

    if (item?.name === undefined || item?.name === '') {
      Object.assign(validateForm, {name: 'Tên khách hàng là bắt buộc.'})
    }

    const regex = /\S+@\S+\.\S+/

    if (item?.email === undefined || item?.email === '') {
      Object.assign(validateForm, {email: 'Email là bắt buộc.'})
    } else if (item?.email.length > 0 && !regex.test(item?.email)) {
      Object.assign(validateForm, {email: 'Email không đúng định dạng.'})
    }

    if (item?.tax === undefined || item?.tax === '') {
      Object.assign(validateForm, {tax: 'Mã số thuế là bắt buộc.'})
    }

    if (item?.billingPamentType === undefined || item?.billingPamentType === '') {
      Object.assign(validateForm, {billingPamentType: 'Hình thức là bắt buộc.'})
    }

    const regexPhone = /^[0-9]\d*$/
    if (!regexPhone.test(item?.phoneNumber) || (item?.phoneNumber.indexOf('0') === 0 && item?.phoneNumber.length !== 10) || (item?.phoneNumber.indexOf('0') !== 0 && item?.phoneNumber.length !== 9)) {
      Object.assign(validateForm, {phoneNumber: 'Số điện thoại không đúng định dạng.'})
    }

    setValidate(validateForm)

    return validateForm
  }

  const handleCancel = () => {
    setIsModalVisible(false)
    _resetCustomerInfo()

    if (type === 'edit') {
      setItem(itemProps)
    } else {
      setItem({})
    }
  }

  const handleOk = async () => {
    Modal.confirm({
      title: 'Confirm',
      icon: <QuestionCircleOutlined/>,
      content: 'Bạn chắc chắn muốn lưu khách hàng này?',
      okText: 'Save',
      cancelText: 'Cancel',
      onOk: onSave
    })
  }

  const confirmCancel = () => {
    Modal.confirm({
      title: 'Confirm',
      icon: <QuestionCircleOutlined/>,
      content: 'Bạn chắc chắn muốn thoát?',
      okText: 'Yes',
      cancelText: 'Cancel',
      onOk: handleCancel
    })
  }

  const onSave = async () => {
    if (type === 'edit') {
      await _onUpdateCustomer()
    } else {
      const response = await _onAddCustomer()

      if (response !== false) {
        handleCancel()
      }
    }
  }

  const _fetchListTenant = async () => {
    try {
      const payload = {
        page: 1,
        limit: 10000
      }
      const response = await searchTenantHub(decodeToken.sub, payload)
      const {success, data, message: error} = response

      if (success !== '1') {
        return message.error(error)
      }

      const _tenants = data.map(item => {
        return {
          label: item.name,
          name: item.name,
          value: item.id,
        }
      })

      setTenants(_tenants)
      setTenantsRaw(data)
    } catch (e) {
      message.error(e.message)
    }
  }

  const _onUpdateCustomer = async () => {
    setLoading(true)

    try {
      const validateCheck = _validateData()

      if (Object.keys(validateCheck).length > 0) {
        setLoading(false)

        return false
      }

      const payload = {
        id: item.id,
        tenantCode: item?.tenantCode || '',
        tenantFullName: item?.name || '',
        tax: item?.tax || '',
        telegramId: item?.telegramId || '',
        phoneNumber: item?.phoneNumber || '',
        email: item?.email || '',
        billingPaymentType: item?.billingPamentType || '',
        salePersonName: item?.salePersonName || '',
        parentId: item?.parentId || '',
        contractNumber: item?.contractNumber || '',
        deputy: item?.deputy || '',
        role: item?.role || '',
        address: item?.address || '',
        tenantIdFee: item?.tenantIdFee || '',
        tenantIdCopy: item?.tenantIdCopy || '',
      }
      const response = await updateTenantHub(payload, decodeToken.sub)

      const {success} = response

      if (success !== '1') {
        setLoading(false)

        return message.error("Cập nhật không thành công.")
      }

      setLoading(false)
      message.success("Cập nhật thành công.")
      handleCancel()
      if (typeof getCustomers === 'function') {
        getCustomers()
      }
      if (typeof fetchLeadDetail === 'function') {
        fetchLeadDetail()
      }
    } catch (e) {
      setLoading(false)
      message.error(e.message)
    }
  }

  const _onAddCustomer = async () => {
    setLoading(true)

    try {
      const validateCheck = _validateData()

      if (Object.keys(validateCheck).length > 0) {
        setLoading(false)

        return false
      }

      const payload = {
        tenantCode: item?.tenantCode || '',
        tenantFullName: item?.name || '',
        tax: item?.tax || '',
        telegramId: item?.telegramId || '',
        phoneNumber: item?.phoneNumber || '',
        email: item?.email || '',
        billingPaymentType: item?.billingPamentType || '',
        salePersonName: item?.salePersonName || '',
        parentId: item?.parentId || '',
        contractNumber: item?.contractNumber || '',
        deputy: item?.deputy || '',
        role: item?.role || '',
        address: item?.address || '',
        tenantIdFee: item?.tenantIdFee || '',
        tenantIdCopy: item?.tenantIdCopy || '',
      }

      const response = await addTenantHub(decodeToken.sub, payload)

      const {data, success, error_message} = response

      if (success !== '1') {
        setLoading(false)

        return message.error(error_message)
      }

      setLoading(false)
      if (typeof setNameCus === 'function') {
        let itemCus = data.length > 0 ? {customerId: data[0].id, name: data[0].name} : {}
        setNameCus(itemCus)
      }
      message.success("Thêm mới khách hàng thành công.")
      if (typeof getCustomers === 'function') {
        getCustomers()
      }
    } catch (e) {
      setLoading(false)
      message.error(e.message)
    }
  }

  const onSaveAndNew = async () => {
    const response = await _onAddCustomer()

    if (response !== false) {
      await _resetCustomerInfo()
    }
  }

  const handleOkAndNew = async () => {
    Modal.confirm({
      title: 'Confirm',
      icon: <QuestionCircleOutlined/>,
      content: 'Bạn chắc chắn muốn lưu và tạo mới khách hàng?',
      okText: 'Save',
      cancelText: 'Cancel',
      onOk: onSaveAndNew
    })
  }

  const _resetCustomerInfo = () => {
    setItem({})
  }

  const _getApParam = async () => {
    try {
      const payload = {
        parType: ['DEFAULT'],
        parCode: ['PAYMENT_METHOD']
      }
      const response = await getApParamV2(payload)
      const {success, data} = response
      if (parseInt(success) !== 1) {
        return
      }
      const _callStatus = data.filter(itemStatus => itemStatus.parCode === 'PAYMENT_METHOD').map(itemStatusM => {
        return {
          name: itemStatusM.parName,
          value: itemStatusM.parValue
        }
      })
      setListTypes(_callStatus)
    } catch (e) {

    }
  }

  useEffect(() => {
    _getApParam()
    _fetchListTenant()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (itemProps) {
      setItem(itemProps)
    }
  }, [itemProps])

  useEffect(() => {
    setItem({
      ...itemProps,
      tenantCode: itemProps?.name || '',
      name: itemProps?.tenantFullName || '',
      parentId: itemProps?.parentId,
      salePersonName: itemProps?.salePersonName
    })
    // eslint-disable-next-line
  }, [itemProps])

  return (
    <Modal
      title={label}
      className="ModalCustom ModalCustomerHub"
      open={isModalVisible}
      onOk={handleOk}
      onCancel={confirmCancel}
      footer={[
        <Button key="back" onClick={confirmCancel}>
          Cancel
        </Button>,
        <Button className={`${type}`} key="submit2" type="primary" loading={loading}
                onClick={handleOkAndNew}>
          Save & New
        </Button>,
        <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
          Save
        </Button>
      ]}
    >
      <div className="FormEdit">
        {/* Row 1: Tenant copy, Mã, Tên khách hàng */}
        <div className="row">
          <div className="FormField col-md-4">
            <label className="Label" htmlFor="tenantIdCopy">
              Tenant copy
            </label>
            <Select
              disabled={type === 'edit'}
              showSearch
              allowClear
              id='tenantIdCopy'
              style={{width: '100%'}}
              value={item?.tenantIdCopy || null}
              onChange={onChangeTenantCopy}
              placeholder={"Chọn tenant để copy thông tin"}
              filterOption={(input, option) => (option.children).toLowerCase().includes(input.toLowerCase())}
            >
              {
                tenants && tenants?.length > 0 && tenants.map(tenant => {
                  return <Select.Option
                    value={tenant.value}
                    key={`tenantCopy_${tenant.value}`}
                  >
                    {tenant.label}
                  </Select.Option>
                })
              }
            </Select>
          </div>
          <div className="FormField col-md-4">
            <label className="Label" htmlFor="tenantCode">
              Mã
            </label>
            <input
              className={`${validate?.tenantCode ? 'Error' : ''}`}
              id="tenantCode"
              type="text"
              name="tenantCode"
              placeholder="Mã..."
              value={item?.tenantCode}
              onChange={onChangeItem}
            />
          </div>
          <div className="FormField col-md-4">
            <label className="Label" htmlFor="name">
              Tên khách hàng
              <span className="Required">*</span>
            </label>
            <input
              className={`${validate?.name ? 'Error' : ''}`}
              id="name"
              type="text"
              name="name"
              placeholder="Tên khách hàng..."
              value={item?.name}
              onChange={onChangeItem}
            />
            {
              validate?.name && <span className="Error">{validate?.name}</span>
            }
          </div>
        </div>

        {/* Row 2: Mã số thuế, Số hợp đồng, Người đại diện */}
        <div className="row">
          <div className="FormField col-md-4">
            <label className="Label" htmlFor="source">
              Mã số thuế
              <span className="Required">*</span>
            </label>
            <input
              className={`${validate.tax ? 'Error' : ''}`}
              id="tax"
              type="text"
              name="tax"
              placeholder="Mã số thuế..."
              value={item?.tax}
              onChange={onChangeItem}
            />
            {
              validate?.tax && <span className="Error">{validate?.tax}</span>
            }
          </div>
          <div className="FormField col-md-4">
            <label className="Label" htmlFor="contractNumber">
              Số hợp đồng
            </label>
            <input
              className={`${validate?.contractNumber ? 'Error' : ''}`}
              id="contractNumber"
              type="text"
              name="contractNumber"
              placeholder="Số hợp đồng..."
              value={item?.contractNumber}
              onChange={onChangeItem}
            />
          </div>
          <div className="FormField col-md-4">
            <label className="Label" htmlFor="deputy">
              Người đại diện
            </label>
            <input
              className={`${validate?.deputy ? 'Error' : ''}`}
              id="deputy"
              type="text"
              name="deputy"
              placeholder="Người đại diện..."
              value={item?.deputy}
              onChange={onChangeItem}
            />
          </div>
        </div>

        {/* Row 3: Chức vụ, Email, Số điện thoại */}
        <div className="row">
          <div className="FormField col-md-4">
            <label className="Label" htmlFor="role">
              Chức vụ
            </label>
            <input
              className={`${validate.role ? 'Error' : ''}`}
              id="role"
              type="text"
              name="role"
              placeholder="Chức vụ..."
              value={item?.role}
              onChange={onChangeItem}
            />
          </div>
          <div className="FormField col-md-4">
            <label className="Label" htmlFor="email">
              Email
              <span className="Required">*</span>
            </label>
            <input
              className={`${validate.email ? 'Error' : ''}`}
              id="email"
              type="text"
              name="email"
              placeholder="Email..."
              value={item?.email}
              onChange={onChangeItem}
            />
            {
              validate?.email && <span className="Error">{validate?.email}</span>
            }
          </div>
          <div className="FormField col-md-4">
            <label className="Label" htmlFor="phoneNumber">
              Số điện thoại
              <span className="Required">*</span>
            </label>
            <input
              className={`${validate.phoneNumber ? 'Error' : ''}`}
              id="phoneNumber"
              type="text"
              name="phoneNumber"
              placeholder="Số điện thoại..."
              value={item?.phoneNumber}
              onChange={onChangeItem}
            />
            {
              validate?.phoneNumber && <span className="Error">{validate?.phoneNumber}</span>
            }
          </div>
        </div>

        {/* Row 4: Địa chỉ, Telegram, Hình thức */}
        <div className="row">
          <div className="FormField col-md-4">
            <label className="Label" htmlFor="address">
              Địa chỉ
            </label>
            <input
              className={`${validate.address ? 'Error' : ''}`}
              id="address"
              type="text"
              name="address"
              placeholder="Địa chỉ..."
              value={item?.address}
              onChange={onChangeItem}
            />
          </div>
          <div className="FormField col-md-4">
            <label className="Label" htmlFor="telegramId">
              Telegram
            </label>
            <input
              id="telegramId"
              type="text"
              name="telegramId"
              placeholder="Tên Telegram"
              value={item?.telegramId}
              onChange={onChangeItem}
            />
          </div>
          <div className="FormField col-md-4">
            <label className="Label" htmlFor="billingPamentType">
              Hình thức
              <span className="Required">*</span>
            </label>
            <Select
              className={`${validate?.billingPamentType ? 'Error' : ''}`}
              name="type"
              id="billingPamentType"
              placeholder="Chọn loại"
              value={item?.billingPamentType || null}
              onChange={(value) => onChangeSelectItem('billingPamentType', value)}>
              {
                !!listTypes && listTypes.length > 0 && listTypes.map((item) => (
                  <Select.Option key={`billingPamentType_${item.value}`}
                                 value={item.value}>{item.name}</Select.Option>
                ))
              }
            </Select>
            {
              validate?.billingPamentType && <span className="Error">{validate?.billingPamentType}</span>
            }
          </div>
        </div>

        {/* Row 5: Thông tin parent, Thông tin sale, Thông tin hoa hồng */}
        <div className="row">
          <div className="FormField col-md-4">
            <label className="Label" htmlFor="parentId">
              Thông tin parent
            </label>
            <Select
              showSearch
              id='parentId'
              style={{width: '100%'}}
              defaultValue=""
              value={item?.parentId || null}
              onChange={(value) => onChangeItemSelect(value, 'parentId')}
              placeholder={"Chọn parent"}
              filterOption={(input, option) => (option.children).toLowerCase().includes(input.toLowerCase())}
            >
              {
                tenants && tenants?.length > 0 && tenants.map(item => {
                  return <Select.Option
                    value={item.value}
                    key={item.value}
                  >
                    {item.label}
                  </Select.Option>
                })
              }
            </Select>
          </div>
          <div className="FormField col-md-4">
            <label className="Label" htmlFor="salePersonName">
              Thông tin sale
            </label>
            <Select
              showSearch
              id='salePersonName'
              style={{width: '100%'}}
              defaultValue=""
              value={item?.salePersonName || null}
              onChange={(value) => onChangeItemSelect(value, 'salePersonName')}
              placeholder={"Chọn sale"}
              filterOption={(input, option) => (option.children).toLowerCase().includes(input.toLowerCase())}
            >
              {
                tenants && tenants?.length > 0 && tenants.map(item => {
                  return <Select.Option
                    value={item.label}
                    key={item.value}
                  >
                    {item.label}
                  </Select.Option>
                })
              }
            </Select>
          </div>
          <div className="FormField col-md-4">
            {
              type === 'edit' && <>
                <label className="Label" htmlFor="tenantIdFee">
                  Thông tin hoa hồng
                </label>
                <Select
                  showSearch
                  id='tenantIdFee'
                  style={{width: '100%'}}
                  defaultValue=""
                  value={item?.tenantIdFee || null}
                  onChange={(value) => onChangeItemSelect(value, 'tenantIdFee')}
                  placeholder={"Chọn người nhận hoa hồng"}
                  filterOption={(input, option) => (option.children).toLowerCase().includes(input.toLowerCase())}
                >
                  {
                    tenants && tenants?.length > 0 && tenants.map(item => {
                      return <Select.Option
                        value={item.value}
                        key={item.value}
                      >
                        {item.name}
                      </Select.Option>
                    })
                  }
                </Select>
              </>
            }
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default CustomerFormModal
